import { Component, inject, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatBadgeModule } from '@angular/material/badge';
import { NotificationsService } from '../../../services/notifications.service';
import { INotifications } from '../../../interfaces/INotifications.interface';

import { DatePipe, SlicePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { ScrollNearEndDirective } from '../../../directives/scrolling.directive';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-notifications',
  imports: [
    MatExpansionModule,
    MatBadgeModule,
    SlicePipe,
    TranslatePipe,
    MatMenuItem,
    MatIcon,
    DatePipe,
    ScrollNearEndDirective,
    MatProgressBar,
  ],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
})
export class NotificationsComponent {
  private _notificationsService = inject(NotificationsService);

  protected notifications = this._notificationsService.notifications;
  protected loading = signal<boolean>(false);
  protected isScrollingDown = signal<boolean>(false);

  protected async onPanelOpen(notification: INotifications) {
    await this._notificationsService.openNotifications(notification);
  }

  protected async onLoadMore(loadMore: boolean) {
    const load = loadMore && this.isScrollingDown();
    if (load) {
      this.loading.set(true);
      await this._notificationsService.loadNextPage();
      this.loading.set(false);
    }
  }

  protected async setIsScrollingDown(down: boolean) {
    this.isScrollingDown.set(down);
  }
}
